import React from 'react';
import { translate } from '../../../utils/translations';
import PropTypes from 'prop-types';
import { check } from '../../../img/';

const ChartInputs = props => (
    <React.Fragment>
        <hr />
        <h3 className="form__heading">
            {translate(props.language, 'form_title_charts')}
        </h3>
        <div className="form__section">
            <div className="form__item" style={{ flexBasis: '41%' }}>
                <label htmlFor="mainChart">
                    {translate(props.language, 'label_main_chart')}
                </label>
                <select
                    name="mainChart"
                    id="mainChart"
                    value={props.mainChart}
                    onChange={props.handleChange}
                    className="select-chart"
                >
                    <option value="estCel">
                        {translate(props.language, 'label_sky_chart')}
                    </option>
                    <option value="vent">
                        {translate(props.language, 'label_wind_chart')}
                    </option>
                </select>
            </div>
            <div className="form__item">
                <label htmlFor="secondaryChart">
                    {translate(props.language, 'label_secondary_chart')}
                </label>
                <input
                    type="checkbox"
                    name="secondaryChart"
                    defaultChecked={props.secondaryChart}
                    onChange={props.handleChange}
                    className="checkbox-secondary-chart"
                />{' '}
                <div
                    className="fake-checkbox"
                    style={{
                        backgroundImage: `url(${check})`,
                    }}
                />
                <span className="sub-label">
                    {translate(
                        props.language,
                        'label_secondary_chart_checkbox'
                    )}
                </span>
            </div>
        </div>
    </React.Fragment>
);

ChartInputs.propTypes = {
    language: PropTypes.string,
    mainChart: PropTypes.string,
    secondaryChart: PropTypes.bool,
    handleChange: PropTypes.func,
};

export default ChartInputs;



// WEBPACK FOOTER //
// ./src/containers/Configurador/FormPartials/ChartInputs.js